<template>
  <rx-role :roles="roles">
    <template>
      <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
        <v-textarea
          v-model="innerValue"
          :dense="dense"
          :label="label"
          v-bind="$attrs"
          v-on="$listeners"
          :error-messages="errors"
          autocomplete="off"
          :messages="message"
          @keyup="checkMaxByte"
           ref="formRef"
        >
          <template v-slot:message="{ message }">
            <div class="text-end">
              <span
                v-dompurify-html="message"
                :class="byteError ? 'red--text' : ''"
              ></span>
            </div>
          </template>
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
        </v-textarea>
      </ValidationProvider>
    </template>
  </rx-role>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import RxRole from "@/redworks/components/base/RxRole";
export default {
  components: {
    ValidationProvider,
    RxRole,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    roles: {
      type: Array,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    byteCounter: {
      type: Object, // ex. { charset: "EUC-KR" } or { charset: "UTF-8" , maxByte: 10 }
    },
  },
  computed: {
    message() {
      if (this.byteCounter) {
        return this.byteCounter.maxByte == null
          ? this.byte + " byte"
          : this.byte + "/" + this.byteCounter.maxByte + " byte";
      } else {
        return "";
      }
    },
    byteError() {
      if (this.byteCounter.maxByte) {
        if (this.byte > this.byteCounter.maxByte) {
          return true;
        }
      }
      return false;
    },
    byte() {
      // Byte 계산하기
      let byte = 0;

      if (this.byteCounter && this.byteCounter.charset == "UTF-8") {
        // UTF-8 : 한글 3 byte
        const textEncoder = new TextEncoder();
        byte = textEncoder.encode(this.value).length;
      } else {
        // EUC-KR : 한글 2 byte
        for (let i = 0; i < this.value.length; i++) {
          let unicode = this.value.charCodeAt(i);
          if (unicode >= 0 && unicode < 256) byte++;
          else byte += 2;
        }
      }
     return byte;
    }
  },
  data: () => ({
    innerValue: "",
  }),
  methods: {
    checkMaxByte(newVal) {
      if (this.byteCounter && this.byte > this.byteCounter.maxByte) {
        newVal = newVal.slice(0, -1);
      }
      return newVal;
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {

      newVal = this.checkMaxByte(newVal);
       
      // maxByte 값이 있을때 입력금지
      const field = this.$refs.formRef;
      field.lazyValue = newVal;

      this.innerValue = newVal;
    },
  },
  mounted() {
    if (this.value) {
      this.innerValue = this.checkMaxByte(this.value);
      // byte 계산
    }
  },
};
</script>

<style></style>
